<template>
  <div class="ResourceManagement">
    <div class="main_top">资源包管理</div>
    <div class="main_title">
      <ul>
      </ul>
      <div class="main_title_right">
        <span class="wenzi">服务</span>
        <a-select v-model:value="services" @change="handleChange" style="width:120px;">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="0">流量包</a-select-option>
          <a-select-option value="1">容量包</a-select-option>
          <a-select-option value="2">预付费</a-select-option>
        </a-select>
        <a-input class="bgm" style="width:160px" placeholder="查询的资源包名称" v-model:value="RoomValue"/>
        <button @click="pagings({current:1,pageSize:paginationObj.pageSize})">查询</button>
        <button style="margin-left:20px" @click="increase">添加</button>
      </div>
    </div>
    <a-table bordered :loading="tableLoading" :columns="columns" :data-source="RoomData" :pagination="paginationObj"
             @change="pagings" :rowKey="(record,index)=>{return index}">
      <!-- 服务类型 -->
      <template #productType="{record}">
        <a-select class="inputs" v-model:value=record.productType :defalueValue=0 style="width:120px;"
                  :disabled="isDisabled(record)"
                  :class="{'inputs_border':isDisabled(record)}">
          <a-select-option :value=0>流量包</a-select-option>
          <a-select-option :value=1>容量包</a-select-option>
          <a-select-option :value=2>预付费</a-select-option>
        </a-select>
      </template>
      <!-- 资源包名称 -->
      <template #productName="{record}">
        <input class="inputs" type="text" v-model="record.productName" :disabled="isDisabled(record)"
               :class="{'inputs_border':isDisabled(record)}"/>
      </template>
      <!-- 描述 -->
      <template #description="{record}">
        <input class="inputs" type="text" v-model="record.description" :disabled="isDisabled(record)"
               :class="{'inputs_border':isDisabled(record)}"/>
      </template>
      <!-- 售价（泰贝） -->
      <template #amount="{record}">
        <input class="inputs" type="text" v-model="record.amount" :disabled="isDisabled(record)"
               :class="{'inputs_border':isDisabled(record)}"/>
      </template>
      <!-- 资源数量 -->
      <template #value="{record}">
        <input class="inputs" type="text" v-model="record.value" :disabled="isDisabled(record)"
               :class="{'inputs_border':isDisabled(record)}"/>
      </template>
      <!-- 有效期 -->
      <template #expirationDuration="{record}">
        <input v-if="isDisplayExpiration(record)" class="inputs" type="text" v-model="record.expirationDuration"
               :disabled="isDisabled(record)"
               :class="{'inputs_border':isDisabled(record)}"/>
      </template>
      <!-- 操作 -->
      <template #operation="{record}">
        <button v-if="isDisplaySaveIco(record)" title="保存" class="rechargess iconfont icon-cunchu"
                @click="addincrease(record)"></button>
        <button v-if="record.isEnable&&!isDisplaySaveIco(record)" title="启用状态" class="rechargess iconfont icon-qiyong"
                @click="prohibit(record)"></button>
        <button v-if="!record.isEnable&&!isDisplaySaveIco(record) " title="禁用状态"
                class="rechargess iconfont icon-jinyong" @click="prohibit(record)"></button>
        <button class="rechargess iconfont icon-shanchu" title="删除" @click="deletes(record)"></button>
      </template>

    </a-table>
  </div>
</template>
<script>
import {myMinxin} from "@/mixin"
import publics from '@/api/public'
import {add, query, updateIsEnable, productServicedelete} from "@/api/api"
import {message} from 'ant-design-vue';
import {methodCallback} from "@/api/methodCallback";
import moment from 'moment'

export default {
  name: "Person",
  mixins: [myMinxin],
  data() {
    return {
      services: '', //服务下拉框
      RoomValue: '', //筛选输入框
      RoomData: [],
      paginationObj: {

        itemRender(current) {
          console.log(current);
          if (current.type === 'prev') {
            return "上一页";
          } else if (current.type === 'next') {
            return "下一页";
          }
          return current.page;
        },
        hideOnSinglePage: true,
        pageSize: 10,
        pageIndex: 1,
        total: 0,
        size: "small",
      },
      columns: publics.columns5,
      tableLoading: true,
      newIncrease: false,
    }
  },
  mounted() {
    this.pagings({current: 1, pageSize: this.paginationObj.pageSize})
  },
  computed: {
    isDisabled: function () {
      return function (record) {
        return record.id !== 0
      }
    },
    isDisplaySaveIco: function () {
      return function (record) {
        return record.id === 0;
      }
    },
    isDisplayExpiration: function () {
      return function (record) {
        return  record.productType != 2||record.id!=0
      }
    }
  },
  methods: {

    pagings(pagination) {
      let data = {
        pageIndex: pagination.current,
        PageSize: pagination.pageSize,
        productType: this.services,
        productName: this.RoomValue,
      }
      query(data)
          .then((res) => {
            if (res.data.code === "SUCCESS") {
              this.tableLoading = false;
              let collections = res.data.data.collections;
              for (let i = 0; i < collections.length; i++) {
                if (collections[i].productType === 2) {
                  collections[i].expirationDuration = "无限制";
                } else {
                  let duration = collections[i].expirationDuration / 60 / 24;
                  collections[i].expirationDuration = duration;
                }
              }
              this.RoomData = collections;
              this.paginationObj.total = res.data.data.total;
            } else if (res.data.code === "NOT_FOUND_DATA") {
              this.RoomData = [];
            } else {
              methodCallback(res);
            }
          })
          .catch((err) => {
            console.log(err)
          });
    },
    handleChange(value) {
      this.conditions = value
    },
    // 禁止启用
    prohibit(record) {
      if (this.newIncrease) {
        this.pagings({current: 1, pageSize: this.paginationObj.pageSize})
        message.success('取消添加');
      } else {
        let data = {
          id: record.id,
          isEnable: !record.isEnable
        }

        updateIsEnable(data)
            .then((res) => {
              if (res.data.code === "SUCCESS") {
                record.isEnable = data.isEnable;
              } else {
                methodCallback(res);
              }
            })
            .catch((err) => {
              console.log(err)
            });
      }
    },
    //删除
    deletes(record) {
      if (record.id === 0) {
        this.RoomData.shift();
        return;
      }
      let data = {
        id: record.id
      }
      productServicedelete(data)
          .then((res) => {
            if (res.data.code === "SUCCESS") {
              this.pagings({current: this.paginationObj.pageIndex, pageSize: this.paginationObj.pageSize})
            } else {
              methodCallback(res);
            }
          })
          .catch((err) => {
            console.log(err)
          });
    },
    //添加房间操作
    increase() {

      this.newIncrease = true
      this.RoomData.unshift(
          {
            id: 0,
            productType: 0,
            productName: '',
            description: '',
            price: '',
            value: '',
            expirationDuration: '',
          }
      )
    },
    //添加房间接口
    addincrease(record) {
      this.tableLoading = true;
      if (record.productName === "") {
        message.warn("请输入产品名称");
        this.tableLoading = false;
        return;
      }
      if (record.amount === "" || record.amount === "0") {
        this.tableLoading = false;
        message.warn("请输入售价");
        return;
      }
      if (record.value === "" || record.value === "0") {
        this.tableLoading = false;
        message.warn("请输入资源数量");
        return;
      }

      if (record.productType == 2) {
        record.expirationDuration = record.value;
      }

      if (record.expirationDuration === "" || record.expirationDuration === 0) {
        this.tableLoading = false;
        message.warn("请输入有效期");
        return;
      }
      let duration = record.expirationDuration * 24 * 60;

      let data = {
        productType: record.productType,
        productName: record.productName,
        description: record.description,
        amount: record.amount,
        value: record.value,
        expirationDuration: duration,
        autoRenew: false,
        limitNumber: -1,
        number: -1,
        expirationTime: 0,
      }
      add(data).then((res) => {
        if (res.data.code === "SUCCESS") {
          this.pagings({current: 1, pageSize: this.paginationObj.pageSize});
          this.newIncrease = false;
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          methodCallback(res);
        }
      }).catch((err) => {
        this.tableLoading = false;
        console.log(err)
      });
    },

  }
}
</script>
<style lang="less" scoped>
.ResourceManagement {
  background: #242526;
  height: 100%;
  border-radius: 4px;

  .main_top {
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-family: Microsoft YaHei, serif;
    font-weight: 400;
    color: #ffffff;
    line-height: 48px;
    text-indent: 30px;
    border-bottom: 1px solid #3f3f3f;
  }

  .main_title {
    display: flex;
    justify-content: space-between;
    padding: 20px 30px 0 30px;

    /deep/ .ant-select-arrow {
      color: rgba(255, 255, 255, 0.6) !important;
    }

    .main_title_right {
      .wenzi {
        font-size: 14px;
        color: #FFFFFF;
        margin-right: 15px;
      }

      /deep/ .ant-select-selector {
        background: #181818 !important;
        border: 1px solid #3f3f3f !important;
        border-radius: 2px !important;
        color: rgba(255, 255, 255, 0.6);
      }

      .bgm {
        background: #181818 !important;
        border: 1px solid #3F3F3F !important;
        border-radius: 2px !important;
        color: rgba(255, 255, 255, .6);
        margin: 0 20px;
      }

      button {
        width: 80px;
        height: 30px;
        background: #1877f2;
        border: none;
        border-radius: 2px;
        cursor: pointer;
        color: #FFF;
      }
    }

    ul {
      display: flex;

      li {
        margin-right: 30px;
        color: #ffffff;

        span {
          margin-right: 20px;
          font-size: 14px;
        }

        /deep/ .ant-input {
          width: 120px;
          height: 30px;
          border: 1px solid #626262;
          background: #181818;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
  }

  .rechargess {
    background: rgb(24, 24, 24);
    border: 0px;
    cursor: pointer;
  }

  .inputs {
    width: 100%;
    background: #1f1f1f;
    border: 1px solid #ccc;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 30px;
  }


  /deep/ .ant-table-placeholder {
    background: #181818;
    border: 1px solid #242526;
    box-sizing: border-box;
  }

  /deep/ .ant-table {
    background: #242526;

    /deep/ .ant-select-selector {
      background: #181818 !important;
      border: 1px solid #3f3f3f;
      border-radius: 2px !important;
      color: rgba(255, 255, 255, 0.6);
    }

    /deep/ .inputs_border {
      border: none !important;
      background: #181818;

      /deep/ .ant-select-selector {
        border: none !important;
        background: #181818;
        color: white;
        cursor: default;
      }

      /deep/ .ant-select-arrow {
        display: none;

      }
    }

    /deep/ .ant-select-arrow {
      color: rgba(255, 255, 255, 0.6);
    }


  }

  /deep/ .ant-pagination {


    /deep/ .ant-pagination-item {
      color: #FFFFFF;

    }

    /deep/ .ant-pagination-item-active {

      color: #1877f2;
      background: none;
    }

    /deep/ .ant-pagination-prev {
      color: #FFFFFF;
      padding: 0 10px 0 0;
    }

    /deep/ .ant-pagination-next {
      color: #FFFFFF;
      padding: 0 0 0 10px;
    }

    /deep/ .ant-pagination-item-link {
      color: #FFFFFF;
      //
      //.anticon-left::after {
      //  content: "上一页";
      //  width: 60px;
      //  color: white;
      //  height: 24px;
      //  line-height: 24px;
      //  display: inline-block;
      //  padding: 0px 10px;
      //}
    }
  }

  /deep/ .ant-table-wrapper {
    box-sizing: border-box;
    padding: 20px 30px;

    .ant-table-content {
      border-radius: 6px;
      overflow: hidden;
    }

    .ant-table-bordered .ant-table-thead > tr > th,
    .ant-table-bordered .ant-table-tbody > tr > td {
      border-right: 1px solid #242526;
    }

    .ant-table-thead > tr > th {
      border-bottom: 1px solid #242526;
    }

    .ant-table-bordered .ant-table-header > table,
    .ant-table-bordered .ant-table-body > table,
    .ant-table-bordered .ant-table-fixed-left table,
    .ant-table-bordered .ant-table-fixed-right table {
      border: 1px solid #242526;
      border-right: 0;
      border-bottom: 0;
    }

    .ant-table-body {
      table {
        background: #181818;

        .ant-table-align-center {
          background: rgba(10, 10, 10, .8);
          color: #fff;
          padding: 3px;
          font-size: 14px;
        }

        .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
          background: #181818 !important;
        }

        .ant-table-row {
          color: #fff;

          td {
            padding: 8px;
            background: #181818;
            border-bottom: 1px solid #242526;

            .ant-input-affix-wrapper {
              .ant-input {
                background: #181818 !important;
                color: #FFF;
                text-align: center;
                border: none;
              }
            }
          }
        }
      }
    }
  }

}
</style>
